const state = {
  show: false,
  message: ''
}

const mutations = {
  showLoading (state, message) {
    state.show = false
    state.message = message
    state.show = true
  },
  hideLoading (state) {
    state.show = false
    state.message = ''
  }
}

const getters = {
  show: state => state.show,
  message: state => state.message
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js